export default {
  log: 'Log',
} as const;
